import { render, staticRenderFns } from "./AppealItemCard.vue?vue&type=template&id=4a826fb3"
import script from "./AppealItemCard.vue?vue&type=script&lang=js"
export * from "./AppealItemCard.vue?vue&type=script&lang=js"
import style0 from "./AppealItemCard.vue?vue&type=style&index=0&id=4a826fb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports